import I18n from 'I18n';
import { Box } from 'foundations-components/transitional/components/Box';
import { Progress as FoundationsProgress } from 'foundations-components/transitional/components/Progress';
import PropTypes from 'prop-types';
import CancelImportButton from './CancelImportButton';
import Message from './Message';
import Progress from './Progress';
import Suggestion from './Suggestion';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Importing = ({
  canWriteArticle,
  importedArticleCount,
  onCancelClick,
  progress,
  totalArticleCount,
  isCancelable = true
}) => {
  const langKey = 'importing';
  return /*#__PURE__*/_jsxs(Progress, {
    alignItems: "center",
    children: [/*#__PURE__*/_jsxs(Box, {
      grow: 1,
      children: [/*#__PURE__*/_jsx(Message, {
        importedArticleCount: importedArticleCount,
        messageLangKey: `${langKey}.message`,
        progress: progress,
        progressLangKey: `${langKey}.progressLabel`,
        totalArticleCount: totalArticleCount
      }), /*#__PURE__*/_jsx(FoundationsProgress, {
        "aria-label": I18n.text('knowledgeContentUI.importArticles.panel.importing.progressLabel', {
          count: progress
        }),
        use: "success",
        value: progress,
        marginBlockEnd: "100"
      }), /*#__PURE__*/_jsx(Suggestion, {
        langKey: langKey
      })]
    }), isCancelable && /*#__PURE__*/_jsx(CancelImportButton, {
      canWriteArticle: canWriteArticle,
      langKey: langKey,
      onClick: onCancelClick
    })]
  });
};
Importing.propTypes = {
  isCancelable: PropTypes.bool,
  canWriteArticle: PropTypes.bool.isRequired,
  importedArticleCount: PropTypes.number.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  progress: PropTypes.number.isRequired,
  totalArticleCount: PropTypes.number.isRequired
};
export default Importing;